/* global wp */
import logo from '../../images/login/logo.png'
import logo2x from '../../images/login/logo@2x.png'
import logo3x from '../../images/login/logo@3x.png'

const { __ } = wp.i18n

const LogoImage = () => {
	return (
		<img
			src={logo}
			srcSet={`${logo} 1x, ${logo2x} 2x, ${logo3x} 3x`}
			className="dashui-onboarding-logo"
			alt={__('Connecting...', 'wpmudev')}
		/>
	)
}

export default LogoImage
